import { sampleDrawLayer } from 'components/MapComponent/constants/sampleLayers';
import { apiPrefix } from 'constants/apiConfig';
import { LayerConfiguration } from './mapEventsEffectTypes';

export const polygon_poweroutage_layer_id = 'polygon_poweroutage_layer_id';
export const polygon_poweroutage_source_id = 'polygon_poweroutage_source_id';
export const polygon_poweroutage_source_layer =
  'public.polygon_poweroutage_source_layer';

export function addPowerOutageLayers({
  addMapEventHandlers,
  addVectorSource,
  checkLayerToggle,
  formattedHoursDatetime,
}: {
  addMapEventHandlers: (layerConfig: LayerConfiguration) => void;
  addVectorSource: (sourceId: string, tiles: string) => void;
  checkLayerToggle: (layerName: string) => boolean;
  formattedHoursDatetime: string;
}) {
  if (checkLayerToggle('Power Outage')) {
    const polygonPoweroutageTiles = `${apiPrefix}/power_outage_tiles/${polygon_poweroutage_source_layer}/{z}/{x}/{y}.pbf`;

    const tilesPath = `${polygonPoweroutageTiles}?datetime_selected=${formattedHoursDatetime}`;

    addVectorSource(polygon_poweroutage_source_id, tilesPath);

    const polygonPoweroutageLayerConfig = {
      ...sampleDrawLayer,
      id: polygon_poweroutage_layer_id,
      source: polygon_poweroutage_source_id,
      'source-layer': polygon_poweroutage_source_layer,
      generateId: true,
      paint: {
        ...sampleDrawLayer.paint,
        'fill-color': [
          'step',
          [
            '*',
            ['/', ['get', 'CustomersOut'], ['get', 'CustomersTracked']],
            100,
          ],
          '#FFFFFF',
          5,
          '#ffffcc',
          10,
          '#a1dab4',
          15,
          '#41b6c4',
          25,
          '#2c7fb8',
          35,
          '#253494',
        ],
      },
      metadata: {
        eventlayer: true,
        usermade: undefined,
      },
    };

    addMapEventHandlers(polygonPoweroutageLayerConfig);
  }
}

export function removePowerOutageLayers({
  removeLayer,
  removeSource,
}: {
  removeLayer: (layerId: string) => void;
  removeSource: (sourceId: string) => void;
}) {
  removeLayer(polygon_poweroutage_layer_id);
  removeSource(polygon_poweroutage_source_id);
}

export function setPowerOutageLayersVisibility({
  setLayerVisibility,
  isVisible,
}: {
  setLayerVisibility: (layerId: string, isVisible: boolean) => void;
  isVisible: boolean;
}) {
  setLayerVisibility(polygon_poweroutage_layer_id, isVisible);
}
